import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import Home from './views/Home'
import About from './views/About'
import Login from './views/Login'
import Config from './views/Config'
import Preview from './views/Preview'
import DocumentList from './views/DocumentList'
import NotFound from './views/NotFound'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: '/documents',
      name: 'documents',
      component: DocumentList,
      meta: {
        auth: true
      }
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview,
      meta: {
        auth: true
      }
    },
    {
      path: '/config',
      name: 'config',
      component: Config,
      meta: {
        auth: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        auth: false
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
      meta: {
        auth: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = store.state.token;
  let auth = to.matched.some(record => record.meta.auth);
  // console.log(to);

  if (auth && !token) {
    console.log("To Login");
    next('login');
  } else {
    console.log("To: ", to);
    next();
  }
});

export default router;
